
import pubDevClient from './pubDevClient.js';
import { getTotalVisitorCount } from '../services/visitorService.js';
import { getPremiumUserCount, getGeneratedProjectCount, getGeneratedPremiumProjectCount } from '../services/userService.js';

const BASE_STATS_DATA = [
  { id: 1, name: 'Toplam Ziyaretçi', value: '0' },
  { id: 2, name: 'Toplam Ücretli Kullanıcı', value: '0' },
  { id: 3, name: 'Ücretsiz Proje Oluşturuldu', value: '0' },
  { id: 4, name: 'Ücretli Proje Oluşturuldu', value: '0' },
  { id: 5, name: 'Haftalık İndirme', value: '0' },
  { id: 6, name: 'Toplam İndirme', value: '0' },
];

let cachedStats = null;
let lastFetchTime = null;
let ongoingRequest = null;
const CACHE_DURATION = 5 * 60 * 1000;

export async function getStatsData(forceRefresh = false, packageName = 'geolocator') {
  if (!forceRefresh && cachedStats && lastFetchTime &&
      (Date.now() - lastFetchTime) < CACHE_DURATION) {
    return cachedStats;
  }

  if (ongoingRequest) {
    return await ongoingRequest;
  }

  ongoingRequest = (async () => {
    try {
      const [packageStats, visitorCount, premiumUserCount, generatedProjectCount, generatedPremiumProjectCount] = await Promise.all([
        pubDevClient.getPackageStats(packageName),
        getTotalVisitorCount(),
        getPremiumUserCount(),
        getGeneratedProjectCount(),
        getGeneratedPremiumProjectCount()
      ]);

    const statsData = BASE_STATS_DATA.map(stat => {
      if (stat.id === 1) {
        return { ...stat, value: visitorCount.toLocaleString('tr-TR') };
      }
      if (stat.id === 2) {
        return { ...stat, value: premiumUserCount.toLocaleString('tr-TR') };
      }
      if (stat.id === 3) {
        return { ...stat, value: generatedProjectCount.toLocaleString('tr-TR') };
      }
      if (stat.id === 4) {
        return { ...stat, value: generatedPremiumProjectCount.toLocaleString('tr-TR') };
      }
      if (stat.id === 5) {
        return { ...stat, value: packageStats.weeklyDownloads };
      }
      if (stat.id === 6) {
        return { ...stat, value: packageStats.totalDownloads };
      }
      return stat;
    });

      cachedStats = statsData;
      lastFetchTime = Date.now();

      return statsData;
    } catch (error) {
      console.error('Error fetching real-time stats:', error);
      return BASE_STATS_DATA;
    } finally {
      ongoingRequest = null;
    }
  })();

  return await ongoingRequest;
}

export async function getPackageMetrics(packageName = 'geolocator') {
  try {
    return await pubDevClient.getPackageStats(packageName);
  } catch (error) {
    console.error('Error fetching package metrics:', error);
    return {
      weeklyDownloads: '0',
      totalDownloads: '0',
      likes: '0',
      pubPoints: 0,
      popularity: 0
    };
  }
}

export const getGeolocatorMetrics = () => getPackageMetrics('geolocator');

export function clearStatsCache() {
  cachedStats = null;
  lastFetchTime = null;
  ongoingRequest = null;
}

const statsService = {
  getStatsData,
  getGeolocatorMetrics,
  clearStatsCache
};

export default statsService;

export { default as cacheManager } from './cacheManager.js';